module.exports = __webpack_public_path__ + "img/cropped-logo.e09cbf06.png";